import { useEffect } from "react";
import Configurator from "../config/Configurator";
import fetchTransmitterRedundancySwitch from "../api/Fetchers/fetch.transmitterRedundancySwitch";

const POLL_INTERVAL_MS = 1000;

/**
 * Polls the transmitter redundancy API every second and redirects the browser
 * to a healthy unit if the currently active one goes down.
 * `cancelled` guards against in-flight async calls completing after unmount.
 */
 export default function useTransmitterRedundancySwitch(enabled = true) {
   useEffect(() => {
     let cancelled = false;
     let intervalId;

     async function start() {
       try {
         const config = await Configurator().catch(() => null);
         if (cancelled) return;
         if (!config) return;

         if (!config.TRANSMITTER_REDUNDANCY_SWITCH_ENABLE) return;

         const tags = config.TRANSMITTER_REDUNDANCY_SWITCH_TAGS || [];
         const addresses = config.TRANSMITTER_REDUNDANCY_SWITCH_ADDRESSES || [];
         const currentAddress = config.TRANSMITTER_REDUNDANCY_SWITCH_ADDRESS;
         if (!tags.length || !addresses.length || !currentAddress) return;

         async function checkRedundancy() {
           try {
             const state = await fetchTransmitterRedundancySwitch().catch(() => ({}));
             if (cancelled) return;

             let stateHasSwitch = false;
             for (let i = 0; i < tags.length; i++) {
               const tag = tags[i];
               const address = addresses[i];
               if (address === currentAddress && state[tag] === false) {
                 stateHasSwitch = true;
                 break;
               }
             }

             if (stateHasSwitch) {
               for (let i = 0; i < tags.length; i++) {
                 const tag = tags[i];
                 const address = addresses[i];
                 if (state[tag] === true) {
                   clearInterval(intervalId);
                   window.location.href = address;
                   return;
                 }
               }
             }
           } catch (error) {
             console.error("Error in checkRedundancy:", error);
           }
         }

         intervalId = setInterval(checkRedundancy, POLL_INTERVAL_MS);
       } catch (error) {
         console.error("Error in start:", error);
       }
     }

     if (enabled) {
       start();
     }

     return () => {
       cancelled = true;
       if (intervalId) {
         clearInterval(intervalId);
       }
     };
   }, [enabled]);
 }
